export const INVALID_CREDENTIALS = "Invalid credentials";
